module.exports = __webpack_public_path__ + "static/img/CO.a9d286d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poker/CO.jpeg
// module id = qjY+
// module chunks = 2